const inputFields = [
  {
    name: "titles",
    type: "text",
    label: "Title",
    placeholder: "",
  },
  {
    name: "name",
    type: "text",
    label: "Name",
  },
  {
    name: "image",
    type: "image",
    label: "Image",
  },
  {
    name: "tokenPrice",
    type: "number",
    label: "Token Price",
    placeholder: "",
  },
  {
    name: "giftType",
    type: "select",
    label: "Gift Type",
    placeholder: "",
    options: [
      {
        label: "Pic",
        value: "pic",
      },
      // {
      //   label: "Video",
      //   value: "video",
      // }
    ],
  },
  {
    name: "description",
    type: "textarea",
    label: "Description",
    placeholder: "",
  },
  {
    name: "prompts",
    type: "textarea",
    label: "Prompt",
    placeholder: "",
  },
];

export default inputFields;
